/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {
    FlagOutlined, InterestsOutlined,
    LinkOutlined,
    MessageOutlined,
    PhoneAndroidOutlined,
    RateReviewOutlined, Star, StartOutlined,
    TitleOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {ESTADOANUNCIOS} from "../../Constantes";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";


const Formulario_Servicio = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOANUNCIOS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Imagen del servicio dimencion 9x7 (peso menor a 300Kb)</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoImagenCrop alto={9} ancho={7}
                                       dato={'img'} {...props}

                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre del cliente'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Testimonio'}
                                  dato={'testimonio'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={Star} nombre={'Calificacion'}
                                  dato={'calificacion'} {...props} opciones={[1,2,3,4,5]}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={InterestsOutlined} nombre={'Redes'}
                                   dato={'redes'} {...props} opciones={['Facebook', 'Instagram', 'Facebook e Instagram']}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Servicio